import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CdkDragDrop } from '@angular/cdk/drag-drop';

import { TranslateService } from '@ngx-translate/core';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-listing-sortable-container',
  templateUrl: './mj-listing-sortable-container.component.html',
  styleUrls: ['./mj-listing-sortable-container.component.scss'],
})
export class MjListingSortableContainerComponent {
  constructor(private translateService: TranslateService) {}

  @Input() public listingItems: JobListingItem[];
  @Output() public onListingUpdated: EventEmitter<any> = new EventEmitter<
    any
  >();

  public onDrop(event: CdkDragDrop<JobListingItem[]>) {
    const _listingItems = [...this.listingItems];
    const newListingItems: JobListingItem[] = this.moveInArray(
      _listingItems,
      event.previousIndex + 1,
      event.currentIndex + 1
    ).map((it, index) => {
      return { ...it, position: index };
    });
    this.onListingUpdated.emit(newListingItems);
  }

  moveInArray(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  public getTitleForItem(item: JobListingItem) {
    return item.title && item.title.length
      ? item.title
      : this.translateService.instant(
          this.getComponentNameTranslationKey(item)
        );
  }

  trackByFn(index, item) {
    return index;
  }

  private getComponentNameTranslationKey(item: JobListingItem): string {
    if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_HEADER) {
      return 'listing_header_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER) {
      return 'listing_footer_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB) {
      return 'listing_about_job_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE) {
      return 'listing_about_office_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB) {
      return 'listing_picture_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT) {
      return 'listing_free_text_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO) {
      return 'listing_video_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE) {
      return 'listing_free_text_picture_element_name';
    } else if (item.type === LISTING_ITEM_TYPE.LISTING_ITEM_JOBS) {
      return 'listing_jobs_element_name';
    } else {
      return ' ';
    }
  }
}
